module.exports = __webpack_public_path__ + "static/media/VictoryAnim.3e28c6d1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/VictoryAnim.gif
// module id = 93
// module chunks = 0